import Cookies from 'js-cookie';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({children}) => {
  const token= Cookies.get("loginToken") == null ? false : true;
  return token? children : <Navigate to="/login" />;  
}

export default PrivateRoute;